import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core'

@Component({
  selector: 'basin-boolean-icon',
  templateUrl: './boolean-icon.component.html',
  styleUrls: ['./boolean-icon.component.scss'],
})
export class BooleanIconComponent {
  @Input() value: boolean = false
  @Output() valueChange = new EventEmitter<boolean>()
  @Input() color: string = 'orange'
  @Input() icon: string = 'icon-star'
  @Input() styleClass: string = ''
  class: string

  ngOnChanges(changes: SimpleChanges): void {
    this.setClass()
  }

  setClass(): void {
    this.class =
      this.icon +
      ' ' +
      (this.value === true ? this.color : '') +
      ' ' +
      this.styleClass
  }

  onValueChange(event: Event): void {
    this.value = !this.value
    this.setClass()
    this.valueChange.emit(this.value)
  }
}
